import { ipfsNftGatewayUri } from '@/data/constants.js'

function shortenHash (hashToShorten) {
  if (!hashToShorten) { return '' }
  return hashToShorten.substr(0, 2) === '0x'
    ? (hashToShorten.substr(0, 6) + '...' + hashToShorten.substr(-4))
    : (hashToShorten.substr(0, 4) + '...' + hashToShorten.substr(-4))
}

function translateIpfsUri (originalUri) {
  if (originalUri.substr(0, 7) === 'ipfs://') {
    return ipfsNftGatewayUri(originalUri.substr(7))
  }
  return originalUri
}

export {
  shortenHash,
  translateIpfsUri
}

export default {
  shortenHash,
  translateIpfsUri
}
